import { inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { map, mergeMap, catchError, switchMap, exhaustMap } from 'rxjs/operators'
import { of } from 'rxjs'
// import { ToastrService } from 'ngx-toastr'
// import { Store } from '@ngrx/store'
// import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import {
  createAppliedLeave,
  createAppliedLeaveFailure,
  createAppliedLeaveSuccess,
  loadAppliedLeaves,
  loadAppliedLeavesFailure,
  loadAppliedLeavesSuccess,
  updateAppliedLeave,
  updateAppliedLeaveFailure,
  updateAppliedLeaveSuccess
} from './applied-leave.actions'
import { AppliedLeaveService } from '../../services/applied-leave.service'
import { ToastrService } from 'ngx-toastr'
import { Store } from '@ngrx/store'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'

export const loadAppliedLeaves$ = createEffect(
  (actions$ = inject(Actions), appliedLeaveService = inject(AppliedLeaveService)) =>
    actions$.pipe(
      ofType(loadAppliedLeaves),
      switchMap(
        (
          action // Use action.filter here
        ) =>
          appliedLeaveService.getAppliedLeaves(action.params, action.page, action.limit).pipe(
            map(res =>
              loadAppliedLeavesSuccess({
                totalCount: res.totalCount,
                appliedLeaves: res.appliedLeaves
              })
            ),
            catchError(error => of(loadAppliedLeavesFailure({ error: error.message })))
          )
      )
    ),
  { functional: true }
)

export const createAppliedLeave$ = createEffect(
  (
    actions$ = inject(Actions),
    appliedLeaveService = inject(AppliedLeaveService),
    toastr = inject(ToastrService), // Inject the ToastrService
    store = inject(Store),
    modalService = inject(NgbModal)
  ) =>
    actions$.pipe(
      ofType(createAppliedLeave),
      exhaustMap(({ payload }) =>
        appliedLeaveService.createAppliedLeave(payload).pipe(
          map(created => {
            // Dispatch the success action
            const successAction = createAppliedLeaveSuccess({ appliedLeave: created })

            // Show a success message using Toastr
            toastr.success('Leave created successfully!', 'Success')
            // store.dispatch(loadAppliedLeaves({ params: null, page: 1, limit: 10 }))
            modalService.dismissAll()
            return successAction
          }),
          catchError(error => {
            // Optionally, show an error message
            toastr.error(error.error.message, 'Error')
            return of(createAppliedLeaveFailure({ error }))
          })
        )
      )
    ),
  { functional: true, dispatch: true }
)

export const updateAppliedLeave$ = createEffect(
  (
    actions$ = inject(Actions),
    appliedLeaveService = inject(AppliedLeaveService),
    toastr = inject(ToastrService),
    store = inject(Store),
    modalService = inject(NgbModal)
  ) =>
    actions$.pipe(
      ofType(updateAppliedLeave),
      exhaustMap(({ id, payload }) =>
        appliedLeaveService.updateAppliedLeave(id, payload).pipe(
          map(updatedAppliedLeave => {
            toastr.success(`Leave ${payload.status}  successfully!`, 'Success')

            // Dispatch loadBusinessById after the update is successful
            // store.dispatch(loadAppliedLeaves({ params: null }))
            modalService.dismissAll()
            // Dispatch success action to update the store
            return updateAppliedLeaveSuccess({ appliedLeave: updatedAppliedLeave })
          }),
          catchError(error => {
            toastr.error('Failed to update AppliedLeave', 'Error') // Show error message
            return of(updateAppliedLeaveFailure({ error }))
          })
        )
      )
    ),
  { functional: true }
)

export const appliedLeaveEffects = {
  loadAppliedLeaves$,
  createAppliedLeave$,
  updateAppliedLeave$
}
